module.exports = __webpack_public_path__ + "assets/img/6f10-xk.svg";